import { render, staticRenderFns } from "./BlacklistManager.vue?vue&type=template&id=1fd7e09c&scoped=true&"
import script from "./BlacklistManager.vue?vue&type=script&lang=js&"
export * from "./BlacklistManager.vue?vue&type=script&lang=js&"
import style0 from "./BlacklistManager.vue?vue&type=style&index=0&id=1fd7e09c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd7e09c",
  null
  
)

export default component.exports